export { default } from "./PopularServices-component";
